import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Loaning} from '../../../common/services/loaning/loaning.model';
import {LoaningService} from '../../../common/services/loaning/loaning.service';
import {LoaningState} from '../../../common/services/loaning/loaning-states.enum';
import {nextStatus, NextStatusLoaning} from './next-state';
import {SubSink} from '@Common/core/utils/subsink';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {MatDialog} from '@angular/material/dialog';
import * as FileSaver from "file-saver";
import {PubSubService} from "@Common/core/services";
import {finalize} from "rxjs/operators";
import {UploadScanDialogComponent} from "../files/upload-scan/upload-scan.component";
import {HelperIndividuService} from "../../../common/services/helper-individu/helper-individu.service";


@Component({
  selector: 'app-take-charge-consultation',
  templateUrl: './take-charge.component.html',
  styleUrls: ['./take-charge.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class TakeChargeConsultationComponent implements OnInit, OnDestroy {
  @Input() loaning: Loaning;
  subSink = new SubSink();
  isGestionnaireOrSuperviseurOrAdmin = true;

  constructor(private dialog: MatDialog,
              private snakeSvc: SnackBarToastyService,
              private helperIndividuService: HelperIndividuService,
              private pubSubSvc: PubSubService,
              public loaningSvc: LoaningService) { }

  ngOnInit(): void {
    this.isGestionnaireOrSuperviseurOrAdmin = this.helperIndividuService.isAdmin ||
            this.helperIndividuService.isSuperviseur ||
            this.helperIndividuService.isGestionnaire;
    console.log(this.isGestionnaireOrSuperviseurOrAdmin);
  }

  exportPdfConsultation() {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.loaningSvc.exportConsultationPdf(this.loaning).pipe(
      finalize(() => this.pubSubSvc.publish('loading', false))
    ).subscribe(
      (_data) => FileSaver.saveAs(_data, `${this.loaning.reference}.pdf`)
    )
  }

  showExportZipBtn() {
    return (this.loaning.status === LoaningState.DONE && this.loaning.scans_obj.length > 0);
  }

  get nextState(): NextStatusLoaning {
    return nextStatus.find(nextState => nextState.status === this.loaning.status);
  }
  public changeState(toState: LoaningState) {
    const data = new DialogData();
    data.title = 'Changement de statut de la demande';
    data.message = `Souhaitez-vous changer le statut de cette demande ?`;
    data.iconType = 'warning';

    const dialogRef = this.dialog?.open(DialogValidationComponent, { data: data });
    dialogRef?.updatePosition({top: '50px'});
    dialogRef?.afterClosed().subscribe(result => {
      if (result) {
        this.loaning.status = toState;
        this.subSink.sink = this.loaningSvc
          .patch(this.loaning, 'uuid')
          .subscribe((_loaning: Loaning) =>
            this.snakeSvc.toasty('Demande de consultation', 'La demande a bien changé de statut', typeToast.success));
      }
    });
  }

  uploadScan() {
    const data = this.loaning
    const dialogRef = this.dialog?.open(UploadScanDialogComponent, { width: '650px',data: data });
    dialogRef?.updatePosition({top: '50px'});
    dialogRef?.afterClosed().subscribe(result => {
      if (result) {
        this.loaning = result;
      }
    });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
